module.exports = __webpack_public_path__ + "static/media/18.0b4a2cde.mp3";